import { createRootRouteWithContext, Link, Outlet, useMatchRoute } from '@tanstack/react-router';

import type { RouterContext } from '../main';

import { AppLayout } from '@/components/layout/AppLayout';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound
});

function RootComponent() {
  const matchRoute = useMatchRoute();
  const isLoginPage = matchRoute({ to: '/login' });

  if (isLoginPage) {
    return <Outlet />;
  }

  return <AppLayout />;
}

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-muted-foreground">Page not found</p>
      <Link to="/" className="text-primary hover:underline">
        Go to Dashboard
      </Link>
    </div>
  );
}
